import getRankColor from "../functions/getRankColor";
import CrownIcon from "./CrownIcon";
import LabelPoint from "./LabelPoints";

export default function PodiumtutorMobile({ props, rank, tutor, handleClick }) {
    if (!tutor) return null;
    let background_color = getRankColor(rank)
    return (
        <div className="grid flex align-items-center p-2 mb-3" style={{
            backgroundColor: 'white',
            borderRadius: '12px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'

        }} onClick={() => handleClick(tutor?.publicId)}>
            <div className={`col-${rank <= 3 ? 8 : 10} flex`}>
                <div className="flex align-items-center mr-3">
                    <span
                        className="flex align-items-center justify-content-center text-white font-bold"
                        style={{
                            width: '28px',
                            height: '28px',
                            backgroundColor: background_color,
                            borderRadius: '50%',
                            fontSize: '0.875rem'
                        }}
                    >
                        {rank}
                    </span>
                </div>

                <div
                    className="mr-3"
                    style={{
                        width: '48px',
                        height: '48px',
                        borderRadius: '50%',
                        overflow: 'hidden',
                        border: rank < 3 ? `3px solid ${background_color}` : `2px solid ${background_color}`
                    }}
                >
                    <img
                        src={tutor.profileImage}
                        alt={`${tutor.name} 프로필`}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        }}
                    />
                </div>

                <div className="flex-1">
                    <h6 className="keduall-typography heading-h6-semibold-600 ranking-tutor-item-name mt-2 ">
                        {tutor.name}
                        {/* <span className={`fi fi-${tutor?.nationality} flag ml-2`}></span>&nbsp; */}
                    </h6>
                    <p className="keduall-typography text-14-normal-400">
                        {tutor && <span>{tutor.points.toLocaleString()}<LabelPoint props={props} /></span>}
                    </p>
                </div>
            </div>

            {rank <= 3 && (
                <div className="col-2">
                    <div style={{ width: 125 }}>
                        <CrownIcon rank={rank}></CrownIcon>
                    </div>
                </div>
            )}

            <div className="col-2">
                <div style={{ width: 100 }}>
                    <h3 className="keduall-typography heading-h3-semibold-600 ranking-tutor-item-name mt-2 ">
                        {/* {tutor.name} */}
                        <span className={`fi fi-${tutor?.nationality} flag ml-2`}></span>
                    </h3>
                </div>
            </div>



        </div>
    );
}